// on native, Error has some extensions that are not present on the browser
// type NativeError = Error & { domain: string };
export class NativeError extends Error {
  domain?: string;
  code?: string;
}
